import request from '@/utils/request'

// 生产环境api路径

// 专家网图   关键词论文 相似关键词搜索框下
export function getRelatedKeyword (data) {
  return request({
    data: data,
    url: '/old/api/queryRelatedKeywords',
    method: 'post'
  })
}

// 提出专家
export function getKeywordAnalysis (data) {
  return request({
    data: data,
    url: '/old/keywordAnalysis ',
    method: 'post'
  })
}

// 翻译
export function getKeywordTranslate (data) {
  return request({
    data: data,
    url: '/old/keywordTranslate',
    method: 'post'
  })
}

// 涉及领域
export function getSankeychart (data) {
  return request({
    data: data,
    url: '/old/api/sankeychart',
    method: 'post'
  })
}

// 英文词云
export function searchCoreKeywordsv2 (data) {
  return request({
    data: data,
    url: '/old/searchCoreKeywordsv2',
    method: 'post'
  })
}

// 开发环境api路径

// 专家网图   关键词论文 相似关键词搜索框下
// export function getRelatedKeyword (data) {
//   return request({
//     data: data,
//     url: 'api/api/queryRelatedKeywords',
//     method: 'post'
//   })
// }

// // 翻译
// export function getKeywordTranslate (data) {
//   return request({
//     data: data,
//     url: 'api/keywordTranslate',
//     method: 'post'
//   })
// }

// // 提出专家
// export function getKeywordAnalysis (data) {
//   return request({
//     data: data,
//     url: 'api/keywordAnalysis',
//     method: 'post'
//   })
// }

// // 涉及领域
// export function getSankeychart (data) {
//   return request({
//     data: data,
//     url: 'api/api/sankeychart',
//     method: 'post'
//   })
// }

// // 英文词云
// export function searchCoreKeywordsv2 (data) {
//   return request({
//     data: data,
//     url: 'api/searchCoreKeywordsv2',
//     method: 'post'
//   })
// }



// WEBPACK FOOTER //
// ./src/api/keyword.js